import React from "react";
import { Check } from "lucide-react";

const CHECKS = [
  { label: "Provider Accreditation", status: "Verified" },
  { label: "Fleet Quality", status: "Confirmed" },
  { label: "Secure Booking", status: "Guaranteed" },
  { label: "Transparent Pricing", status: "No hidden costs" },
];

export default function MoveTrust() {
  return (
    <section className="relative overflow-hidden bg-[#012d6e] py-20">
      <div className="pointer-events-none absolute right-0 top-0 h-[400px] w-[500px] rounded-full bg-[#017bef]/[0.15] blur-[64px]" />

      <div className="relative mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-[16px] sm:px-8 lg:grid-cols-2">
        <div>
          <span className="inline-block rounded-full border-[1px] border-solid border-white/[0.15] bg-white/10 px-[16px] py-1.5 text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white/70">
            Trust
          </span>
          <h2 className="pt-[20px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-white sm:text-[48px] sm:leading-[48px]">
            Book With Confidence
          </h2>
          <p className="pt-[20px] text-[18px] leading-[29.25px] text-white/60">
            Book with confidence through accredited rental providers. Every provider on SPACIA MOVE is accredited and
            verified before listing.
          </p>

          <ul className="space-y-[12px] pt-8">
            {CHECKS.map(check => (
              <li
                key={check.label}
                className="flex items-center justify-between rounded-[14px] border-[1px] border-solid border-white/10 bg-white/[0.06] px-[20px] py-[12px]"
              >
                <span className="text-[14px] leading-5 text-white/70">{check.label}</span>
                <span className="flex items-center gap-1.5 text-[12px] font-semibold leading-4 text-[#86efac]">
                  <Check className="size-[11px]" />
                  {check.status}
                </span>
              </li>
            ))}
          </ul>

          <p className="pt-10 text-[14px] leading-[22.75px] text-white/40">
            Know what you're paying for — transparent pricing with no hidden surprises.
          </p>
        </div>

        <div className="relative h-[360px] overflow-hidden rounded-3xl sm:h-[492px]">
          <img
            src="/figma-assets/move/trust.jpg"
            alt="Car pickup at a hotel entrance"
            className="absolute inset-0 size-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[rgba(1,45,110,0.6)] to-transparent" />
        </div>
      </div>
    </section>
  );
}
